export default __webpack_public_path__ + "static/media/white-tee.a3a22e31.jpg";